/* DM TELCO - OUR OWN PRODUCT SEARCH AND FILTERS
   Loaded by layout/theme.liquid when the theme setting "Product search and filters"
   (Theme settings > DM Product Search & Filters) is DM Telco's own, or on a page opened with
   ?view=dm. It draws what the Boost app used to draw: the collection pages, the search results
   and the answers under the search box in the header. The frame is snippets/dm-catalogue.liquid.

   HOW IT IS FAST. The whole catalogue is about 1,200 products, 54 KB when compressed: smaller
   than one product photo. So nothing is asked of a server while someone searches or filters.
     - A collection of up to 250 products is written into its page by Shopify: the first screen
       needs no request at all.
     - The whole catalogue (for the search) is fetched once from Shopify, in the background,
       and kept by the browser for ten minutes.
   Searching and filtering then happen here, in a few thousandths of a second, as you type.

   NOTHING TO MAINTAIN. Every filter is the first part of a product tag (Material_HDG gives the
   filter Material and the choice HDG), or the product type, or the brand. A new choice, or a
   whole new kind of tag, shows up by itself. The order, the names and which tags are never
   filters are theme settings (CFG below), not code.

   PRICES. A visitor sees Shopify's price. A trade login never does: its cards are priced by the
   ordering platform (assets/dm-b2b.js, window.dmB2bEngine.card), exactly as Boost's cards were.
   This file never asks for, holds or shows a trade price itself except through that script. */
(function () {
  'use strict';
  var CFG = window.dmCatalogue;
  if (!CFG || !CFG.on) return;
  var ENGINE = window.dmB2bEngine || null;
  // A login on the ordering platform is priced and buys through it, and never gets a visitor's
  // price or Shopify's cart, not even if the platform's own script did not load.
  var TRADE = CFG.platform === 'engine';
  var SPARK = CFG.platform === 'sparklayer';              // the fallback: priced on the product page
  var PER_PAGE = Math.max(12, Number(CFG.perPage) || 48);

  /* ═══ Small tools ══════════════════════════════════════════════ */
  // A list looked up by a word someone typed, or by the first part of a tag. Made with nothing
  // inherited, so the word "constructor" finds nothing instead of a piece of JavaScript.
  var dict = function (from) { var d = Object.create(null); if (from) Object.keys(from).forEach(function (k) { d[k] = from[k]; }); return d; };
  var $ = function (id) { return document.getElementById(id); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  };
  var money = function (cents) {
    return '$' + (Number(cents) / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  var natural = (function () {
    try { return new Intl.Collator('en', { numeric: true, sensitivity: 'base' }).compare; }
    catch (e) { return function (a, b) { return a < b ? -1 : a > b ? 1 : 0; }; }
  })();
  var picture = function (src, width) { return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + width; };
  var productUrl = function (p) { return '/products/' + encodeURIComponent(p.h); };
  // A look at it before it is switched on (?view=dm): keep the links inside the look.
  var keep = function (url) {
    if (!CFG.preview || /[?&]view=/.test(url)) return url;
    return url + (url.indexOf('?') < 0 ? '?' : '&') + 'view=dm';
  };

  /* ═══ The search ═══════════════════════════════════════════════
     One search for this page, the header and the Old Skool Pricelist: assets/dm-search.js, loaded
     before this file (owner 2026-10-14: the two "should have the same search functionality"). */
  var SEARCH = window.dmSearch;
  if (!SEARCH) { console.error('DM catalogue: assets/dm-search.js did not load'); return; }
  var buildSearch = SEARCH.build;
  var words = SEARCH.words, indexWords = SEARCH.indexWords, singular = SEARCH.singular, term = SEARCH.term, isNumber = SEARCH.isNumber;

  /* ═══ A product, made ready ════════════════════════════════════
     f = what it can be filtered by: { 'material': ['HDG'], 'product type': ['Cable Ladder'], … }
     o = its place in DM Sort (the DMSORT tag); stock = [class, words] for its stock label. */
  var HIDDEN = dict();
  String(CFG.hidden == null ? 'DMSORT, Sort, STATUS' : CFG.hidden).split(',').forEach(function (h) { if (h.trim()) HIDDEN[h.trim().toLowerCase()] = true; });
  var NAMES = dict({ 'product type': 'Product Type', vendor: 'Vendor' });   // how each kind of tag is written, first seen

  // The same ladder the Boost cards used (it lived in Boost's own editor). Cable ladder is made to
  // order by the supplier, so it is never "Backorder": with none on the shelf it is Drop Shipped.
  function stockOf(p) {
    var q = Number(p.q) || 0;
    if (p.y === 'Cable Ladder') return q > 1 ? ['in-stock', 'In Stock'] : q === 1 ? ['low-stock', 'Low Stock'] : ['drop-shipped', 'Drop Shipped'];
    if (p.a === false || q <= 0) return ['out-of-stock', 'Backorder'];
    if (q <= 1) return ['low-stock', 'Low Stock'];
    return ['in-stock', 'In Stock'];
  }
  function ready(p) {
    if (p.f) return p;
    var f = dict();
    if (p.y) f['product type'] = [p.y];
    if (p.b) f.vendor = [p.b];
    p.o = null;
    (p.g || []).forEach(function (tag) {
      var i = tag.indexOf('_');
      if (i <= 0) return;
      var name = tag.slice(0, i).trim();
      var key = name.toLowerCase();
      var val = tag.slice(i + 1).trim();
      if (key === 'dmsort') { if (val !== '' && !isNaN(Number(val))) p.o = Number(val); return; }
      if (!val || HIDDEN[key]) return;
      if (!NAMES[key]) NAMES[key] = name;
      if (!f[key]) f[key] = [];
      if (f[key].indexOf(val) < 0) f[key].push(val);
    });
    p.f = f;
    p.stock = stockOf(p);
    return p;
  }

  // The filters to show and in what order: the theme setting first, then (if allowed) any other
  // kind of tag the products carry. A line is "Prefix", "Prefix = Name" or either with "| swatch".
  var WANTED = String(CFG.filters || '').split(/\r?\n/).map(function (line) {
    var style = /\|\s*swatch\s*$/i.test(line) ? 'swatch' : 'list';
    var rest = line.replace(/\|.*$/, '');
    var parts = rest.split('=');
    var key = parts[0].trim().toLowerCase();
    if (key === 'brand') key = 'vendor';
    return key ? { key: key, label: (parts[1] || '').trim(), style: style } : null;
  }).filter(Boolean);
  function filterList(products) {
    var seen = dict();
    products.forEach(function (p) { Object.keys(p.f).forEach(function (k) { seen[k] = true; }); });
    var out = [];
    var used = dict();
    WANTED.forEach(function (w) {
      if (!seen[w.key] || used[w.key] || HIDDEN[w.key]) return;
      used[w.key] = true;
      out.push({ key: w.key, label: w.label || NAMES[w.key] || w.key, style: w.style });
    });
    if (CFG.auto !== false) {
      Object.keys(seen).filter(function (k) { return !used[k]; }).sort(natural).forEach(function (k) {
        out.push({ key: k, label: NAMES[k] || k, style: 'list' });
      });
    }
    return out;
  }

  /* ═══ Getting the catalogue ════════════════════════════════════ */
  // Kept apart for trade logins and visitors: a product tagged b2b-only is in the first and not the second.
  var INDEX_KEY = 'dmCat:index:1:' + (CFG.platform ? 'trade' : 'guest');
  var FRESH_MS = 10 * 60 * 1000;     // used as it is
  var KEEP_MS = 60 * 60 * 1000;      // used at once, and fetched again behind it
  function readJson(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector('script[data-dm-catalogue-index]');
    return el ? JSON.parse(el.textContent) : null;
  }
  // Every page of one collection's products, 250 a request. `url` is the collection's own address.
  function fetchPages(url) {
    var at = function (n) {
      return fetch(url + (url.indexOf('?') < 0 ? '?' : '&') + 'section_id=dm-catalogue-index&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('HTTP ' + r.status)); })
        .then(pageOf);
    };
    return at(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= first.pages; n++) rest.push(at(n));
      return Promise.all(rest).then(function (more) { return together([first].concat(more)); });
    });
  }
  function pageOf(html) {
    var j = readJson(html);
    if (!j) throw new Error('no catalogue in the answer');
    return j;
  }
  function together(pages) {
    var products = [];
    pages.forEach(function (m) { products = products.concat(m.products || []); });
    // null = a trade-only product, left out for a visitor (snippets/dm-catalogue-item.liquid)
    return { products: products.filter(Boolean), collections: pages[0].collections || [] };
  }
  // The whole catalogue. On a page that needs it at once, snippets/dm-catalogue.liquid has already
  // asked for every part of it (CFG.early) while the page was still arriving: those answers are
  // used. If any of them is missing or short, it is asked for again the ordinary way.
  function fetchCatalogue() {
    var url = CFG.allUrl || '/collections/all';
    var early = CFG.early;
    CFG.early = null;
    if (!early || !early.length) return fetchPages(url);
    return Promise.all(early).then(function (texts) {
      var pages = texts.map(pageOf);
      if (pages[0].pages > pages.length) throw new Error('more of the catalogue than was asked for');
      return together(pages);
    }).catch(function () { return fetchPages(url); });
  }
  var indexPromise = null;
  function loadIndex() {
    if (indexPromise) return indexPromise;
    var cached = null;
    try { cached = JSON.parse(localStorage.getItem(INDEX_KEY)); } catch (e) { /* storage blocked or empty */ }
    var age = cached && cached.t ? Date.now() - cached.t : Infinity;
    // Used only if it is what it should be: a list of products, with something in it, kept in the
    // past. Anything else (cut short, an older shape, a clock that was wrong) is thrown away.
    var good = !!cached && Array.isArray(cached.products) && cached.products.length > 0 && age >= 0 && age < KEEP_MS;
    if (cached && !good) {
      try { localStorage.removeItem(INDEX_KEY); localStorage.removeItem(INDEX_KEY + ':t'); } catch (e) { /* storage blocked */ }
    }
    var fresh = function () {
      return fetchCatalogue().then(function (ix) {
        try {
          localStorage.setItem(INDEX_KEY, JSON.stringify({ t: Date.now(), products: ix.products, collections: ix.collections }));
          // when it was kept, on its own: the page's first script reads only this (snippets/dm-catalogue.liquid)
          localStorage.setItem(INDEX_KEY + ':t', String(Date.now()));
        } catch (e) { /* storage full or blocked */ }
        return ix;
      });
    };
    if (good) {
      if (age >= FRESH_MS) fresh().catch(function () { /* the kept copy stands */ });
      indexPromise = Promise.resolve({ products: cached.products.filter(Boolean), collections: Array.isArray(cached.collections) ? cached.collections : [] });
    } else {
      indexPromise = fresh().catch(function (err) { indexPromise = null; throw err; });
    }
    indexPromise = indexPromise.then(function (ix) { ix.products.forEach(ready); return ix; });
    return indexPromise;
  }
  var searchOf = (function () {
    var built = new Map();   // one search per list of products (a collection, or everything)
    return function (products) {
      if (!built.has(products)) built.set(products, buildSearch(products, { synonyms: CFG.synonyms, skip: HIDDEN }));
      return built.get(products);
    };
  })();
  // Collections whose name has every word typed ("cable tie" -> Cable Ties, Cable Ties - Nylon).
  function collectionsFor(query, collections) {
    var typed = words(query).map(term).filter(Boolean);
    if (!typed.length) return [];
    return collections.filter(function (c) {
      var have = indexWords(c.t).map(singular);
      return typed.every(function (t) { return have.some(function (h) { return isNumber(t) ? h === t : h.indexOf(t) === 0; }); });
    }).sort(function (a, b) { return a.t.length - b.t.length || natural(a.t, b.t); });
  }

  /* ═══ A product card ═══════════════════════════════════════════
     The look is the one the Boost cards had (the styles moved from assets/boost-sd-custom.css to
     assets/dm-catalogue.css). A visitor's card has the price, a quantity and ADD TO CART; a trade
     login's card is priced and given its buttons by the ordering platform. */
  function qtyBox() {
    return '<div class="dm-quantity-wrapper">' +
      '<button type="button" class="dm-qty-btn" data-dm-cat-step="-1" aria-label="Decrease quantity">-</button>' +
      '<input type="number" name="quantity" value="1" min="1" class="dm-qty-input" aria-label="Quantity">' +
      '<button type="button" class="dm-qty-btn" data-dm-cat-step="1" aria-label="Increase quantity">+</button>' +
      '</div>';
  }
  function cardHtml(p, eager) {
    var url = productUrl(p);
    var img = p.m
      ? '<img src="' + esc(picture(p.m, 360)) + '" srcset="' + esc(picture(p.m, 240)) + ' 240w, ' + esc(picture(p.m, 360)) + ' 360w, ' + esc(picture(p.m, 540)) + ' 540w"' +
        ' sizes="(min-width: 990px) 220px, (min-width: 750px) 30vw, 44vw" alt="" width="360" height="360" loading="' + (eager ? 'eager' : 'lazy') + '" decoding="async">'
      : '<span class="dm-cat-card__noimg">' + (CFG.logo ? '<img src="' + esc(CFG.logo) + '" alt="" loading="lazy" decoding="async">' : '') + '<em>Picture coming soon</em></span>';
    var buy = '';
    if (SPARK) buy = '<div class="dm-custom-actions"><a class="dm-boost-atc-btn" href="' + url + '">VIEW PRODUCT</a></div>';
    else if (!TRADE) buy = '<div class="dm-custom-actions dm-cat-actions">' + qtyBox() + '<button type="button" class="dm-boost-atc-btn dm-cat-atc">ADD TO CART</button></div>';
    return '<li class="dm-cat-card" data-sku="' + esc(p.s) + '" data-variant="' + esc(p.v) + '" data-handle="' + esc(p.h) + '">' +
      '<a class="dm-cat-card__media" href="' + url + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<div class="dm-cat-card__info">' +
        '<a class="dm-cat-card__title" href="' + url + '">' + esc(p.t) + '</a>' +
        (TRADE || SPARK ? '' : '<div class="dm-cat-card__price">' + money(p.p) + '</div>') +
        '<div class="dm-inventory-label ' + p.stock[0] + '">' + p.stock[1] + '</div>' +
        buy +
      '</div></li>';
  }
  // "Show all items", the first tile. Owner, 2026-10-13: "all that should do is just clear the
  // filters. Shouldn't do anything more than that." So while anything narrows the page (a filter,
  // or words in the page's search box) the tile takes that off and stays on the page: nothing
  // else changes. With nothing to take off, in a category, it leads to all products.
  function allTileHtml(narrowed) {
    var href = narrowed ? window.location.pathname + (CFG.preview ? '?view=dm' : '') : keep(CFG.allUrl || '/collections/all');
    return '<li class="dm-cat-card dm-cat-card--all"><a href="' + esc(href) + '" data-act="show-all">' +
      (CFG.logo ? '<img src="' + esc(CFG.logo) + '" alt="" decoding="async">' : '') + '<strong>Show all items</strong></a></li>';
  }
  // A trade login's price and buttons: the ordering platform's own code does it, card by card.
  function priceCards(scope) {
    if (!TRADE || !ENGINE || !ENGINE.card) return;
    scope.querySelectorAll('.dm-cat-card[data-sku]:not([data-priced])').forEach(function (card) {
      card.setAttribute('data-priced', '');
      try { ENGINE.card(card); } catch (e) { console.error('DM catalogue: card not priced', e); }
    });
  }

  /* ═══ A visitor's cart ═════════════════════════════════════════
     Shopify's own cart, through the theme's own "added to your cart" pop-up. (A trade login's
     ADD TO CART is the ordering platform's and never comes here.) */
  var toastTimer = 0;
  function toast(text) {
    var t = document.querySelector('.dm-cat-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'dm-cat-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.textContent = text;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 4500);
  }
  // The number on the cart icon, from what Shopify sent back with the add.
  function cartCount(data) {
    try {
      var html = data && data.sections && data.sections['cart-icon-bubble'];
      var icon = document.getElementById('cart-icon-bubble');
      if (!html || !icon) return;
      var got = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (got) icon.innerHTML = got.innerHTML;
    } catch (e) { /* the count is right on the next page */ }
  }
  function addToCart(btn) {
    var card = btn.closest('.dm-cat-card');
    var box = btn.closest('.dm-cat-actions');
    if (!card || !box || btn.disabled) return;
    var label = btn.textContent;
    var quantity = Math.max(1, parseInt(box.querySelector('.dm-qty-input').value, 10) || 1);
    var popup = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { id: Number(card.getAttribute('data-variant')), quantity: quantity };
    if (popup && typeof popup.getSectionsToRender === 'function') {
      body.sections = popup.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    btn.disabled = true;
    btn.textContent = 'ADDING…';
    var done = function (text) {
      btn.textContent = text;
      setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1200);
    };
    fetch((CFG.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data || {} }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          toast(res.data.description || res.data.message || 'That could not be added to your cart.');
          return done(label);
        }
        if (btn.closest('.dm-cat-instant')) {
          // Under the header search the theme's pop-up would open behind the tiles, where it cannot
          // be seen or reached. Say so in a line at the foot of the screen and put the new count on
          // the cart icon ourselves.
          cartCount(res.data);
          toast('Added to your cart.');
        } else if (popup && typeof popup.renderContents === 'function') {
          try { popup.renderContents(res.data); } catch (e) { console.error('DM catalogue: cart pop-up', e); }
        }
        done('ADDED ✓');
      })
      .catch(function () { toast('No connection. Please check your internet and try again.'); done(label); });
  }
  document.addEventListener('click', function (e) {
    var step = e.target.closest('.dm-cat-actions [data-dm-cat-step]');
    if (step) {
      var input = step.parentElement.querySelector('.dm-qty-input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.getAttribute('data-dm-cat-step')));
      return;
    }
    var atc = e.target.closest('.dm-cat-atc');
    if (atc) return addToCart(atc);
    // a look at it before it is switched on: links to other collections and searches stay in the look
    if (CFG.preview) {
      var a = e.target.closest('a[href]');
      if (a && a.origin === window.location.origin && /^\/(collections|search)(\/|$)/.test(a.pathname) && !/[?&]view=/.test(a.search)) {
        a.search += (a.search ? '&' : '?') + 'view=dm';
      }
    }
  }, true);

  /* ═══ The collection page and the search results page ═════════ */
  var root = $('dm-catalogue');
  var PAGE = null;        // what Shopify wrote into the page (snippets/dm-catalogue.liquid)
  var BASE = [];          // every product this page is about
  var FILTERS = [];       // the filters these products can be narrowed by
  var COLLECTIONS = [];
  var S = { q: '', sort: '', sel: dict(), shown: 0, tab: 'products', shut: dict(), loose: false };
  var LIST = [];          // what is showing: BASE, searched, filtered and sorted
  var WHOLE = false;      // BASE is every product: this is the page of all products
  var HOME = null;        // the address of that page, once a category has become it (see widen)
  var SORTS = [['dm', 'DM Sort'], ['relevance', 'Relevance'], ['az', 'Name, A to Z'], ['za', 'Name, Z to A'], ['price-asc', 'Price, low to high'], ['price-desc', 'Price, high to low']];
  var COLOURS = dict({ black: '#111', white: '#fff', red: '#d32f2f', blue: '#1565c0', green: '#2e7d32', yellow: '#fbc02d', orange: '#F96449', grey: '#9e9e9e', gray: '#9e9e9e', brown: '#6d4c41', purple: '#7b1fa2', pink: '#ec407a', clear: 'transparent', natural: '#e8dcc0', silver: '#c0c0c0', teal: '#01ADB9', violet: '#7b1fa2', beige: '#e8dcc0', gold: '#c9a227' });

  function defaultSort() { return S.q ? 'relevance' : 'dm'; }
  // a trade login whose company keeps prices from them (Customer Roles b2b_0059): set early by layout/theme.liquid
  function noPrices() { return document.documentElement.classList.contains('dm-no-prices'); }
  function sortNow() { return S.sort || defaultSort(); }
  // What a product is sorted by under "Price". A trade login is sorted by its OWN price, from the
  // ordering platform, and never by the visitor's: a product whose trade price is not known (not
  // loaded yet, or "call for price") goes last either way round.
  function priceFor(p) {
    if (!TRADE) return Number(p.p) || 0;
    var t = ENGINE && ENGINE.priceOf ? ENGINE.priceOf(p.s) : undefined;
    return typeof t === 'number' ? t * 100 : null;
  }
  function byPrice(up) {
    return function (a, b) {
      var x = priceFor(a);
      var y = priceFor(b);
      if (x === null || y === null) return (x === null ? 1 : 0) - (y === null ? 1 : 0) || natural(a.t, b.t);
      return (up ? x - y : y - x) || natural(a.t, b.t);
    };
  }
  // The trade price list arrives a moment after the page: once it has, a list sorted by price is
  // put in its real order (looked for a few times, then left).
  var priceWait = 0;
  function sortAgainWhenPriced() {
    if (!TRADE || priceWait || !/^price-/.test(sortNow()) || !LIST.length) return;
    if (LIST.some(function (p) { return priceFor(p) !== null; })) return;
    var tries = 0;
    priceWait = setInterval(function () {
      tries += 1;
      var ready = LIST.some(function (p) { return priceFor(p) !== null; });
      if (!ready && tries < 40 && /^price-/.test(sortNow())) return;
      clearInterval(priceWait);
      priceWait = 0;
      if (ready && /^price-/.test(sortNow())) paint(true);
    }, 250);
  }
  // Does the product pass every filter that has something chosen (leaving one filter out)?
  function passes(p, except) {
    for (var key in S.sel) {
      if (key === except) continue;
      var want = S.sel[key];
      if (!want || !want.length) continue;
      var have = p.f[key];
      if (!have) return false;
      var hit = false;
      for (var i = 0; i < have.length; i++) if (want.indexOf(have[i]) >= 0) { hit = true; break; }
      if (!hit) return false;
    }
    return true;
  }
  function compute() {
    var pool = BASE;
    S.loose = false;
    if (S.q) {
      var found = searchOf(BASE).search(S.q);
      S.loose = found.loose;
      pool = found.map(function (r) { return BASE[r.i]; });
    }
    // how many each choice would give, counted with every OTHER filter applied
    var counts = dict();
    FILTERS.forEach(function (f) {
      var c = dict();
      pool.forEach(function (p) {
        if (!passes(p, f.key)) return;
        (p.f[f.key] || []).forEach(function (v) { c[v] = (c[v] || 0) + 1; });
      });
      counts[f.key] = c;
    });
    var list = pool.filter(function (p) { return passes(p); });
    var sort = sortNow();
    if (sort === 'dm') list = list.slice().sort(function (a, b) { return (a.o == null ? 1e9 : a.o) - (b.o == null ? 1e9 : b.o) || natural(a.t, b.t); });
    else if (sort === 'az') list = list.slice().sort(function (a, b) { return natural(a.t, b.t); });
    else if (sort === 'za') list = list.slice().sort(function (a, b) { return natural(b.t, a.t); });
    else if (sort === 'price-asc') list = list.slice().sort(byPrice(true));
    else if (sort === 'price-desc') list = list.slice().sort(byPrice(false));
    LIST = list;
    return counts;
  }

  function swatch(value) {
    var parts = String(value).toLowerCase().split(/[\/&,]+/).map(function (s) { return COLOURS[s.trim()]; });
    if (parts.some(function (c) { return !c; })) return '';
    var bg = parts.length === 1 ? parts[0] : 'linear-gradient(90deg, ' + parts.map(function (c, i) { return c + ' ' + (i * 100 / parts.length) + '% ' + ((i + 1) * 100 / parts.length) + '%'; }).join(', ') + ')';
    return '<span class="dm-cat-swatch" style="background:' + bg + '"></span>';
  }
  function paintFilters(counts) {
    var box = $('dmCatFilters');
    if (!box) return;
    var focus = document.activeElement && document.activeElement.closest ? document.activeElement.closest('#dmCatFilters input') : null;
    var focusAt = focus ? [focus.getAttribute('data-key'), focus.value] : null;
    // Each filter's choices scroll in their own box (owner 2026-10-20: "a scroll area within each of the filter
    // trees", not "+ 10 more"). Drawing the filters again (a box ticked) keeps where each box was scrolled to.
    var scrolled = dict();
    Array.prototype.forEach.call(box.querySelectorAll('.dm-cat-filter__opts'), function (o) {
      scrolled[o.getAttribute('data-key')] = o.scrollTop;
    });
    var html = '<div class="dm-cat-filters__head"><strong>Filter</strong><button type="button" class="dm-cat-filters__close" data-act="filters-close" aria-label="Close filters">&times;</button></div>';
    FILTERS.forEach(function (f) {
      var chosen = S.sel[f.key] || [];
      var c = counts[f.key] || {};
      var values = Object.keys(c).concat(chosen.filter(function (v) { return !c[v]; })).sort(natural);
      if (!values.length) return;
      var rows = values.map(function (v) {
        var on = chosen.indexOf(v) >= 0;
        return '<label class="dm-cat-opt' + (on ? ' is-on' : '') + '">' +
          '<input type="checkbox" data-key="' + esc(f.key) + '" value="' + esc(v) + '"' + (on ? ' checked' : '') + '>' +
          (f.style === 'swatch' ? swatch(v) : '') +
          '<span class="dm-cat-opt__name">' + esc(v) + '</span><span class="dm-cat-opt__n">(' + (c[v] || 0) + ')</span></label>';
      }).join('');
      html += '<details class="dm-cat-filter" data-key="' + esc(f.key) + '"' + (S.shut[f.key] ? '' : ' open') + '>' +
        '<summary>' + esc(f.label) + '</summary><div class="dm-cat-filter__opts" data-key="' + esc(f.key) + '">' + rows + '</div>' +
        '</details>';
    });
    html += '<div class="dm-cat-filters__foot"><button type="button" class="dm-boost-atc-btn" data-act="filters-close">Show ' + LIST.length + ' product' + (LIST.length === 1 ? '' : 's') + '</button></div>';
    box.innerHTML = html;
    Array.prototype.forEach.call(box.querySelectorAll('.dm-cat-filter__opts'), function (o) {
      var key = o.getAttribute('data-key');
      if (scrolled[key] != null) { o.scrollTop = scrolled[key]; return; }
      // drawn for the first time: a ticked choice further down (a menu link, an address) starts in view
      var on = o.querySelector('.dm-cat-opt.is-on');
      if (on && on.offsetTop + on.offsetHeight > o.clientHeight) o.scrollTop = on.offsetTop - 8;
    });
    if (focusAt) {
      var again = Array.prototype.filter.call(box.querySelectorAll('input[type="checkbox"]'), function (i) { return i.getAttribute('data-key') === focusAt[0] && i.value === focusAt[1]; })[0];
      if (again) again.focus();
    }
  }
  function paintChips() {
    var box = $('dmCatChips');
    if (!box) return;
    var html = '';
    FILTERS.forEach(function (f) {
      (S.sel[f.key] || []).forEach(function (v) {
        html += '<button type="button" class="dm-cat-chip" data-act="chip" data-key="' + esc(f.key) + '" data-value="' + esc(v) + '" aria-label="Remove ' + esc(f.label + ': ' + v) + '">' +
          '<span>' + esc(f.label) + ':</span> ' + esc(v) + ' <i aria-hidden="true">&times;</i></button>';
      });
    });
    if (html) html += '<button type="button" class="dm-cat-chip dm-cat-chip--clear" data-act="clear">Clear all</button>';
    box.innerHTML = html;
    box.hidden = !html;
  }
  // Is anything narrowing this page: a filter, or words in its search box?
  function narrowed() {
    return !!S.q || Object.keys(S.sel).some(function (k) { return S.sel[k] && S.sel[k].length; });
  }
  // The tile shows on a collection page whenever it has something to do: always in a category,
  // and on the page of all products only while something narrows it.
  function showsAllTile() {
    return CFG.allTile !== false && PAGE.mode === 'collection' && (narrowed() || !WHOLE);
  }
  function paintGrid(more) {
    var grid = $('dmCatGrid');
    var from = more ? S.shown : 0;
    var to = Math.min(LIST.length, from + PER_PAGE);
    var html = '';
    if (!more && showsAllTile()) html += allTileHtml(narrowed());
    for (var i = from; i < to; i++) html += cardHtml(LIST[i], !more && i < 8);
    if (more) grid.insertAdjacentHTML('beforeend', html);
    else grid.innerHTML = html;
    S.shown = to;
    priceCards(grid);
    $('dmCatMore').hidden = S.shown >= LIST.length;
  }
  function paintNote() {
    var note = $('dmCatNote');
    var text = '';
    var chosen = Object.keys(S.sel).some(function (k) { return S.sel[k] && S.sel[k].length; });
    if (!LIST.length) {
      text = !BASE.length ? 'There are no products here yet.'
        : S.q && !chosen ? 'Nothing found for "' + S.q + '". Check the spelling, try fewer words, or search by item code.'
        : 'No products match what is chosen. Take a filter off to see more.';
    } else if (S.q && S.loose) {
      text = 'No product has every word of "' + S.q + '". These are the closest.';
    }
    note.textContent = text;
    note.hidden = !text;
    note.classList.toggle('dm-cat-note--empty', !LIST.length);
  }
  function paintTabs() {
    var tabs = $('dmCatTabs');
    if (!tabs) return;
    var cols = S.q ? collectionsFor(S.q, COLLECTIONS) : [];
    tabs.hidden = !S.q;
    tabs.innerHTML =
      '<button type="button" role="tab" data-act="tab" data-tab="products" aria-selected="' + (S.tab === 'products') + '">Products (' + LIST.length + ')</button>' +
      '<button type="button" role="tab" data-act="tab" data-tab="collections" aria-selected="' + (S.tab === 'collections') + '">Collections (' + cols.length + ')</button>';
    var list = $('dmCatCollections');
    list.innerHTML = cols.map(function (c) {
      return '<li><a href="' + esc(keep('/collections/' + encodeURIComponent(c.h))) + '"><strong>' + esc(c.t) + '</strong><span>' + c.n + ' product' + (c.n === 1 ? '' : 's') + '</span></a></li>';
    }).join('') || '<li class="dm-cat-collections__none">No collection has that name.</li>';
    var onCols = S.tab === 'collections' && !!S.q;
    list.hidden = !onCols;
    root.classList.toggle('dm-cat--collections', onCols);
  }
  // keepGrid: leave the cards alone when the list they show has not changed
  function paint(keepFilters, keepGrid) {
    var codes = function () { return LIST.map(function (p) { return p.s; }).join('\n'); };
    var before = keepGrid ? codes() : null;
    var counts = compute();
    if (!keepFilters) paintFilters(counts);
    paintChips();
    $('dmCatCount').textContent = LIST.length + ' Product' + (LIST.length === 1 ? '' : 's');
    var sort = $('dmCatSort');
    // (a login that sees no prices, Customer Roles b2b_0059: no sorting by them)
    sort.innerHTML = SORTS.filter(function (s) { return (s[0] !== 'relevance' || S.q) && !(/^price-/.test(s[0]) && noPrices()); }).map(function (s) {
      return '<option value="' + s[0] + '"' + (s[0] === sortNow() ? ' selected' : '') + '>' + s[1] + '</option>';
    }).join('');
    paintNote();
    if (before === null || before !== codes()) paintGrid(false);
    paintTabs();
    var title = $('dmCatTitle');
    if (title) title.textContent = S.q ? 'Search results for "' + S.q + '"' : 'Search';
    root.classList.add('dm-cat--ready');
    sortAgainWhenPriced();
  }

  // The address says what is showing, so a filtered list can be bookmarked, sent to someone, and
  // the Back button returns to it: the search, sort, and one f.<filter> per choice. The search is
  // "q" on the search page (Shopify's own name for it) and "find" on a collection page, where "q"
  // already means something else to Shopify (/collections/vendors?q=Atkore).
  function qKey() { return PAGE && PAGE.mode === 'search' ? 'q' : 'find'; }
  function writeUrl() {
    var u = new URL(window.location.href);
    var p = u.searchParams;
    Array.from(p.keys()).forEach(function (k) { if (k === qKey() || k === 'sort' || k === 'page' || k.indexOf('f.') === 0) p.delete(k); });
    if (S.q) p.set(qKey(), S.q);
    if (S.sort && S.sort !== defaultSort()) p.set('sort', S.sort);
    Object.keys(S.sel).forEach(function (k) { (S.sel[k] || []).forEach(function (v) { p.append('f.' + k, v); }); });
    // a category that opened as filters on all products IS the page of all products from then on
    if (HOME) p.delete('q');
    try { window.history.replaceState(null, '', (HOME || u.pathname) + (p.toString() ? '?' + p.toString() : '') + u.hash); } catch (e) { /* not allowed here */ }
  }
  function readUrl() {
    var p = new URL(window.location.href).searchParams;
    S.q = (p.get(qKey()) || '').trim();
    S.sort = SORTS.some(function (s) { return s[0] === p.get('sort'); }) && !(/^price-/.test(p.get('sort') || '') && noPrices()) ? p.get('sort') : '';
    S.sel = dict();
    p.forEach(function (v, k) {
      if (k.indexOf('f.') !== 0 || !v) return;
      var key = k.slice(2).toLowerCase();
      if (!S.sel[key]) S.sel[key] = [];
      if (S.sel[key].indexOf(v) < 0) S.sel[key].push(v);
    });
  }
  function change(keepFilters) {
    writeUrl();
    paint(keepFilters);
  }
  // A login that sees no prices (Customer Roles b2b_0059) is marked on <html> by the price engine, on the first page of
  // a session only once its price list has come: then a price sort (asked for or chosen) goes and the box loses it, and
  // the other way round if the company shows them prices again (review 2026-10-21)
  function watchPrices() {
    if (!window.MutationObserver) return;
    var was = noPrices();
    new MutationObserver(function () {
      var now = noPrices();
      if (now === was) return;
      was = now;
      if (now && /^price-/.test(S.sort || '')) S.sort = '';
      if (root.classList.contains('dm-cat--ready')) change(true);
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  function wire() {
    watchPrices();
    root.addEventListener('change', function (e) {
      var box = e.target.closest('#dmCatFilters input[type="checkbox"]');
      if (box) {
        var key = box.getAttribute('data-key');
        var have = S.sel[key] || [];
        S.sel[key] = box.checked ? have.concat(box.value) : have.filter(function (v) { return v !== box.value; });
        if (!S.sel[key].length) delete S.sel[key];
        return change();
      }
      if (e.target.id === 'dmCatSort') { S.sort = e.target.value; return change(true); }
    });
    root.addEventListener('toggle', function (e) {
      var d = e.target.closest ? e.target.closest('.dm-cat-filter') : null;
      if (d) S.shut[d.getAttribute('data-key')] = !d.open;
    }, true);
    root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-act]');
      if (!el) return;
      var act = el.getAttribute('data-act');
      if (act === 'chip') {
        var key = el.getAttribute('data-key');
        S.sel[key] = (S.sel[key] || []).filter(function (v) { return v !== el.getAttribute('data-value'); });
        if (!S.sel[key].length) delete S.sel[key];
        return change();
      }
      if (act === 'clear') { S.sel = dict(); return change(); }
      if (act === 'show-all') {
        // with nothing narrowing the page the tile is an ordinary link (to all products)
        if (!narrowed()) return;
        e.preventDefault();
        S.sel = dict();
        S.q = '';
        if (S.sort === 'relevance') S.sort = '';
        var box = $('dmCatQ');
        if (box) box.value = '';
        return change();
      }
      if (act === 'filters-close') return drawer(false);
      if (act === 'tab') { S.tab = el.getAttribute('data-tab'); return paintTabs(); }
    });
    var q = $('dmCatQ');
    if (q) {
      q.value = S.q;
      var timer = 0;
      q.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var next = q.value.trim();
          if (next === S.q) return;
          // a search starts in order of relevance, and going back to no search returns to DM Sort
          if (!S.sort || S.sort === 'relevance' || S.sort === 'dm') S.sort = '';
          S.q = next;
          S.tab = 'products';
          change();
        }, 90);
      });
      // on a collection page the box narrows this page; Enter must not leave it
      if (PAGE.mode === 'collection') q.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    }
    $('dmCatMoreBtn').addEventListener('click', function () { paintGrid(true); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && S.shown < LIST.length) paintGrid(true);
      }, { rootMargin: '900px 0px' }).observe($('dmCatMore'));
    }
    $('dmCatFilterBtn').addEventListener('click', function () { drawer(true); });
    $('dmCatScrim').addEventListener('click', function () { drawer(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer(false); });
    // The search form on the results page: the list below already follows the box as it is typed in.
    var form = root.querySelector('form[data-dm-search-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); if (q) q.blur(); });
  }
  function drawer(open) {
    root.classList.toggle('dm-cat--filters-open', open);
    $('dmCatScrim').hidden = !open;
    $('dmCatFilterBtn').setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('dm-cat-locked', open);
  }
  function start(products, collections) {
    BASE = products.map(ready);
    COLLECTIONS = collections || [];
    FILTERS = filterList(BASE);
    // a choice in the address that these products do not have is dropped, not left invisible
    Object.keys(S.sel).forEach(function (k) { if (!FILTERS.some(function (f) { return f.key === k; })) delete S.sel[k]; });
    wire();
    paint();
  }
  function failed(err) {
    console.error('DM catalogue: products could not be loaded', err);
    var note = $('dmCatNote');
    note.hidden = false;
    note.classList.add('dm-cat-note--empty');
    note.innerHTML = 'The products could not be loaded. <button type="button" class="dm-cat-chip" onclick="window.location.reload()">Try again</button>';
    $('dmCatGrid').innerHTML = '';
  }
  function startPage() {
    try { PAGE = JSON.parse($('dm-catalogue-page').textContent); } catch (e) { PAGE = null; }
    if (!PAGE) return;
    readUrl();
    if (PAGE.mode === 'search') {
      if (!S.q && PAGE.terms) S.q = String(PAGE.terms).trim();
      return loadIndex().then(function (ix) { start(ix.products, ix.collections); }).catch(failed);
    }
    if (PAGE.products) {
      start(PAGE.products.filter(Boolean), []);
      return widen();
    }
    // A collection too large to be written into its page. Its products are fetched from the
    // address this page is at, so a page narrowed by Shopify itself (/collections/all/<tag>,
    // /collections/vendors?q=Atkore) gets the same products it was given. Only "all products",
    // plain, is the whole catalogue the browser already keeps.
    var here = new URL(window.location.href);
    var path = here.pathname.replace(/\/+$/, '');
    var shopQ = here.searchParams.get('q');
    if (path === allPath() && !shopQ) {
      WHOLE = true;
      return loadIndex().then(function (ix) { start(ix.products, ix.collections); }).catch(failed);
    }
    return fetchPages(path + (shopQ ? '?q=' + encodeURIComponent(shopQ) : '')).then(function (ix) { start(ix.products, ix.collections); return widen(); }).catch(failed);
  }
  function allPath() { return String(CFG.allUrl || '/collections/all').replace(/\/+$/, ''); }

  /* ═══ A category is all products with its filters on ══════════
     Owner, 2026-10-13, of the Products menu: "instead of going to a collection page, all it
     does is put the filters on. On the all products page."
     The menu's links are still collection links, and the collection's own products are on screen
     at once, as before. When the whole catalogue has arrived (it was asked for as the page
     arrived, or the browser already had it) this page BECOMES the page of all products, narrowed
     by the filters that give exactly these products: Product Type: Cable Ladder, Subcategory:
     Bends. The cards on screen do not change. What changes: the filters offer every choice, the
     chips show what is on, the address is the all-products address with those filters, taking a
     filter off widens the list, and "Show all items" takes them all off.
     Nothing is kept anywhere about which filters make which collection: it is worked out from the
     products and their tags each time, so a collection or a tag changed in Shopify needs nothing
     done here. A collection that no filters describe exactly stays a page of its own. */
  function filtersFor(part, all) {
    if (!part.length || part.length >= all.length) return null;
    // what every product of the collection has in common, in the order of the filters
    var shared = [];
    filterList(all).forEach(function (f) {
      (part[0].f[f.key] || []).forEach(function (v) {
        if (part.every(function (p) { return (p.f[f.key] || []).indexOf(v) >= 0; })) shared.push([f.key, v]);
      });
    });
    var count = function (pairs) {
      var n = 0;
      all.forEach(function (p) { if (pairs.every(function (kv) { return (p.f[kv[0]] || []).indexOf(kv[1]) >= 0; })) n++; });
      return n;
    };
    // The fewest filters, the product type first, that give this many products. Every product of
    // the collection has them, so "this many" means "exactly these".
    var type = shared.filter(function (kv) { return kv[0] === 'product type'; })[0];
    var rest = shared.filter(function (kv) { return kv !== type; });
    var tries = [];
    var pairs = [];
    rest.forEach(function (a, i) { rest.slice(i + 1).forEach(function (b) { if (a[0] !== b[0]) pairs.push([a, b]); }); });
    if (type) {
      tries.push([type]);
      rest.forEach(function (x) { tries.push([type, x]); });
    }
    rest.forEach(function (x) { tries.push([x]); });
    pairs.forEach(function (ab) { tries.push(ab); });
    if (type) pairs.forEach(function (ab) { tries.push([type].concat(ab)); });
    // ...and "exactly these" is then checked product by product, because the kept catalogue can be up
    // to an hour older than the page: one product in and one out leaves the count the same.
    var mine = dict();
    part.forEach(function (p) { mine[String(p.v)] = true; });
    var same = function (pairs) {
      return all.every(function (p) {
        var has = pairs.every(function (kv) { return (p.f[kv[0]] || []).indexOf(kv[1]) >= 0; });
        return has === !!mine[String(p.v)];
      });
    };
    for (var i = 0; i < tries.length; i++) {
      if (count(tries[i]) !== part.length || !same(tries[i])) continue;
      var out = dict();
      tries[i].forEach(function (kv) { out[kv[0]] = [kv[1]]; });
      return out;
    }
    return null;
  }
  function widen() {
    if (CFG.onePage === false || !PAGE || PAGE.mode !== 'collection' || WHOLE) return null;
    var part = BASE;
    return loadIndex().then(function (ix) {
      if (WHOLE || BASE !== part) return;
      var on = filtersFor(part, ix.products);
      if (!on) return;
      // What the visitor has chosen in the meantime stays chosen. If that is in one of the same
      // filters, the two cannot be told apart afterwards: this page view stays as it is.
      if (Object.keys(on).some(function (k) { return S.sel[k] && S.sel[k].length; })) return;
      Object.keys(on).forEach(function (k) { S.sel[k] = on[k]; });
      BASE = ix.products;
      COLLECTIONS = ix.collections || [];
      FILTERS = filterList(BASE);
      WHOLE = true;
      HOME = allPath();
      writeUrl();
      paint(false, true);
    }).catch(function (err) {
      // the collection is on screen and works by itself; the wider page will come another time
      console.warn('DM catalogue: the whole catalogue could not be loaded', err);
    });
  }

  /* ═══ The search box in the header ═════════════════════════════
     Type, pause, and what was found is laid out as product tiles under the box: the same cards as
     the collection pages, with the picture, the price, the stock label and ADD TO CART. There is
     no list of names to read through, and nothing to press: it happens by itself a moment after
     the typing stops. Enter, or "See all", opens the full results page with its filters.
     Owner, 2026-10-13: "it shows in the tiled windows what the search results are. Not brings
     them in a little list. And automatically does that after a certain time." */
  var INSTANT_WAIT_MS = 250;   // how long after the last key
  var INSTANT_TILES = 12;      // three rows of four
  function wireInstant() {
    var forms = Array.prototype.filter.call(document.querySelectorAll('form[data-dm-search-form]'), function (f) { return !root || !root.contains(f); });
    forms.forEach(function (form) {
      var input = form.querySelector('input[type="search"]');
      if (!input) return;
      input.setAttribute('autocomplete', 'off');
      var panel = document.createElement('div');
      panel.className = 'dm-cat-instant';
      panel.hidden = true;
      form.parentNode.insertBefore(panel, form.nextSibling);
      var seq = 0;
      var timer = 0;
      var place = function () {
        // the tiles hang under the box, as wide as the page allows
        var top = Math.round(input.getBoundingClientRect().bottom + 10);
        panel.style.top = top + 'px';
        panel.style.maxHeight = Math.max(200, window.innerHeight - top - 16) + 'px';
      };
      var close = function () { seq++; clearTimeout(timer); panel.hidden = true; panel.innerHTML = ''; };
      var show = function () {
        var q = input.value.trim();
        var mine = ++seq;
        if (q.length < 2) return close();
        loadIndex().then(function (ix) {
          if (mine !== seq) return;
          var found = searchOf(ix.products).search(q);
          var cols = collectionsFor(q, ix.collections).slice(0, 4);
          var all = keep((CFG.searchUrl || '/search') + '?q=' + encodeURIComponent(q));
          var html = '';
          if (found.length) {
            html += '<div class="dm-cat-instant__head"><strong>' + found.total + ' product' + (found.total === 1 ? '' : 's') + ' for "' + esc(q) + '"</strong>' +
              '<a class="dm-cat-instant__all" href="' + esc(all) + '">See all, with filters</a></div>';
            if (found.loose) html += '<p class="dm-cat-instant__note">No product has every word. These are the closest.</p>';
          } else {
            html += '<p class="dm-cat-instant__note dm-cat-instant__note--none">Nothing found for "' + esc(q) + '". Check the spelling, try fewer words, or search by item code.</p>';
          }
          if (cols.length) {
            html += '<div class="dm-cat-instant__cols"><span>Collections:</span>' + cols.map(function (c) {
              return '<a class="dm-cat-chip" href="' + esc(keep('/collections/' + encodeURIComponent(c.h))) + '">' + esc(c.t) + '</a>';
            }).join('') + '</div>';
          }
          if (found.length) {
            html += '<ul class="dm-cat-grid dm-cat-grid--instant" role="list">' + found.slice(0, INSTANT_TILES).map(function (r) { return cardHtml(ix.products[r.i], true); }).join('') + '</ul>';
            if (found.total > INSTANT_TILES) html += '<div class="dm-cat-more"><a class="dm-cat-morebtn" href="' + esc(all) + '">See all ' + found.total + ' results</a></div>';
          }
          panel.innerHTML = html;
          panel.scrollTop = 0;
          place();
          panel.hidden = false;
          priceCards(panel);
        }).catch(function () {
          if (mine !== seq) return;
          panel.innerHTML = '<p class="dm-cat-instant__note dm-cat-instant__note--none">Press Enter to search.</p>';
          place();
          panel.hidden = false;
        });
      };
      input.addEventListener('input', function () {
        clearTimeout(timer);
        if (input.value.trim().length < 2) return close();
        timer = setTimeout(show, INSTANT_WAIT_MS);
      });
      input.addEventListener('focus', function () {
        loadIndex().catch(function () { /* asked for again when something is typed */ });
        if (panel.hidden && input.value.trim().length >= 2) show();
      });
      form.addEventListener('reset', close);
      window.addEventListener('resize', function () { if (!panel.hidden) place(); });
      // the theme's search opens and closes as a <details>: the tiles close with it
      var details = form.closest('details');
      if (details) details.addEventListener('toggle', function () { if (!details.open) close(); });
    });
  }

  /* ═══ Start ════════════════════════════════════════════════════ */
  // Switched on for the whole theme while the Boost app is still on too: Boost draws over the
  // collection and search pages. Its two switches (Theme settings > App embeds) must be off.
  if (!CFG.preview && window.boostSDAppConfig) console.warn('DM catalogue: the Boost app embed is still switched on in this theme. Turn off its two switches under App embeds.');
  // for tests, and for looking at it from the browser's console
  CFG.api = { buildSearch: buildSearch, collectionsFor: collectionsFor, stockOf: stockOf, ready: ready, filterList: filterList, loadIndex: loadIndex, state: S, list: function () { return LIST; } };
  wireInstant();
  if (root) startPage();
  // Have the whole catalogue ready for the search box before it is first used, without getting
  // in the way of the page: fetched when the browser has nothing else to do.
  var warm = function () { loadIndex().catch(function () { /* asked for again when the box is used */ }); };
  if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 4000 });
  else setTimeout(warm, 1500);
})();
